module.exports = __webpack_public_path__ + "static/media/heart5.306d2c8b.svg";